document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-fam-product]').forEach(initFamProduct);
});

function initFamProduct(root) {
  var dataEl = root.querySelector('[data-fam-variants]');
  if (!dataEl) return;
  var variants = JSON.parse(dataEl.textContent);
  var optionCount = root.querySelectorAll('[data-fam-option-group]').length;
  var selected = root.getAttribute('data-fam-initial-options').split('|||');

  var variantIdInput = root.querySelector('[data-fam-variant-id]');
  var priceEl = root.querySelector('[data-fam-price]');
  var comparePriceEl = root.querySelector('[data-fam-compare-price]');
  var addBtn = root.querySelector('[data-fam-add-to-basket]');
  var availabilityEl = root.querySelector('[data-fam-availability]');
  var mainImage = root.querySelector('[data-fam-main-image]');

  function setMainImage(url) {
    if (!mainImage || !url) return;
    // srcset/sizes take priority over src in the browser's image selection,
    // so they must be cleared or the old image keeps rendering even though
    // .src has visibly changed.
    mainImage.removeAttribute('srcset');
    mainImage.removeAttribute('sizes');
    mainImage.src = url;
  }

  function findVariant() {
    return variants.find(function (v) {
      return v.options.every(function (val, i) { return val === selected[i]; });
    });
  }

  function render() {
    var variant = findVariant();
    if (!variant) return;

    root.querySelectorAll('[data-fam-option-group]').forEach(function (group) {
      var index = parseInt(group.getAttribute('data-fam-option-group'), 10);
      group.querySelectorAll('[data-fam-value]').forEach(function (btn) {
        btn.classList.toggle('selected', btn.getAttribute('data-fam-value') === selected[index]);
      });
    });

    if (variantIdInput) variantIdInput.value = variant.id;
    if (priceEl) priceEl.textContent = variant.price;
    if (comparePriceEl) {
      if (variant.compare_at_price) {
        comparePriceEl.textContent = variant.compare_at_price;
        comparePriceEl.style.display = '';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? addBtn.getAttribute('data-fam-label-available') : addBtn.getAttribute('data-fam-label-soldout');
    }
    if (availabilityEl) {
      availabilityEl.textContent = variant.available ? availabilityEl.getAttribute('data-fam-in-stock-label') : availabilityEl.getAttribute('data-fam-oos-label');
      availabilityEl.classList.toggle('fam-in-stock', variant.available);
      availabilityEl.classList.toggle('fam-out-stock', !variant.available);
    }
    if (variant.featured_image) {
      setMainImage(variant.featured_image);
    }
  }

  root.querySelectorAll('[data-fam-option-group] [data-fam-value]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var index = parseInt(btn.closest('[data-fam-option-group]').getAttribute('data-fam-option-group'), 10);
      selected[index] = btn.getAttribute('data-fam-value');
      render();
    });
  });

  var thumbs = root.querySelectorAll('[data-fam-thumb]');

  function activateThumb(thumb) {
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    thumb.classList.add('active');
    setMainImage(thumb.getAttribute('data-fam-full-src'));
    thumb.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      activateThumb(thumb);
    });
  });

  var thumbsTrack = root.querySelector('[data-fam-thumbs-track]');
  var thumbsPrev = root.querySelector('[data-fam-thumbs-prev]');
  var thumbsNext = root.querySelector('[data-fam-thumbs-next]');
  if (thumbsTrack && thumbsPrev && thumbsNext) {
    function thumbsStep() {
      var firstThumb = thumbsTrack.querySelector('[data-fam-thumb]');
      return firstThumb ? firstThumb.getBoundingClientRect().width * 3 : 200;
    }
    thumbsPrev.addEventListener('click', function () {
      thumbsTrack.scrollBy({ left: -thumbsStep(), behavior: 'smooth' });
    });
    thumbsNext.addEventListener('click', function () {
      thumbsTrack.scrollBy({ left: thumbsStep(), behavior: 'smooth' });
    });
  }

  if (mainImage) {
    mainImage.style.cursor = 'zoom-in';
    mainImage.addEventListener('click', function () {
      var activeIndex = Math.max(0, [].findIndex.call(thumbs, function (t) { return t.classList.contains('active'); }));
      openFamLightbox(thumbs, activeIndex);
    });
  }

  var stepper = root.querySelector('[data-fam-qty-stepper]');
  if (stepper) {
    stepper.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn) return;
      var input = stepper.querySelector('input');
      var val = parseInt(input.value, 10) || 1;
      val = btn.getAttribute('data-fam-qty-action') === 'increase' ? val + 1 : Math.max(1, val - 1);
      input.value = val;
    });
  }

  render();
}

var famLightboxState = { urls: [], index: 0 };

function famLightboxEls() {
  return {
    root: document.querySelector('[data-fam-lightbox]'),
    image: document.querySelector('[data-fam-lightbox-image]'),
  };
}

function openFamLightbox(thumbs, index) {
  var urls = thumbs.length
    ? [].map.call(thumbs, function (t) { return t.getAttribute('data-fam-zoom-src') || t.getAttribute('data-fam-full-src'); })
    : [document.querySelector('[data-fam-main-image]').src];
  famLightboxState = { urls: urls, index: index || 0 };
  var els = famLightboxEls();
  if (!els.root) return;
  renderFamLightbox();
  els.root.classList.add('fam-open');
  document.body.style.overflow = 'hidden';
}

function closeFamLightbox() {
  var els = famLightboxEls();
  if (!els.root) return;
  els.root.classList.remove('fam-open');
  document.body.style.overflow = '';
}

function stepFamLightbox(delta) {
  var count = famLightboxState.urls.length;
  if (!count) return;
  famLightboxState.index = (famLightboxState.index + delta + count) % count;
  renderFamLightbox();
}

function renderFamLightbox() {
  var els = famLightboxEls();
  if (!els.image) return;
  els.image.src = famLightboxState.urls[famLightboxState.index];
}

document.addEventListener('DOMContentLoaded', function () {
  var els = famLightboxEls();
  if (!els.root) return;
  var closeBtn = els.root.querySelector('[data-fam-lightbox-close]');
  var prevBtn = els.root.querySelector('[data-fam-lightbox-prev]');
  var nextBtn = els.root.querySelector('[data-fam-lightbox-next]');
  if (closeBtn) closeBtn.addEventListener('click', closeFamLightbox);
  if (prevBtn) prevBtn.addEventListener('click', function () { stepFamLightbox(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { stepFamLightbox(1); });
  els.root.addEventListener('click', function (e) {
    if (e.target === els.root) closeFamLightbox();
  });
  document.addEventListener('keydown', function (e) {
    if (!els.root.classList.contains('fam-open')) return;
    if (e.key === 'Escape') closeFamLightbox();
    if (e.key === 'ArrowLeft') stepFamLightbox(-1);
    if (e.key === 'ArrowRight') stepFamLightbox(1);
  });
});

document.addEventListener('click', function (e) {
  var tabBtn = e.target.closest('[data-fam-tab-button]');
  if (!tabBtn) return;
  var section = tabBtn.closest('[data-fam-tabs]');
  section.querySelectorAll('[data-fam-tab-button]').forEach(function (b) { b.classList.remove('active'); });
  section.querySelectorAll('[data-fam-tab-panel]').forEach(function (p) { p.classList.remove('active'); });
  tabBtn.classList.add('active');
  section.querySelector('[data-fam-tab-panel="' + tabBtn.getAttribute('data-fam-tab-button') + '"]').classList.add('active');
});

document.addEventListener('DOMContentLoaded', function () {
  var modal = document.querySelector('[data-fam-quote-modal]');
  if (!modal) return;
  var closeBtn = modal.querySelector('[data-fam-quote-modal-close]');

  function openQuoteModal() {
    modal.classList.add('fam-open');
    document.body.style.overflow = 'hidden';
  }
  function closeQuoteModal() {
    modal.classList.remove('fam-open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-fam-open-quote-modal]').forEach(function (btn) {
    btn.addEventListener('click', openQuoteModal);
  });
  if (closeBtn) closeBtn.addEventListener('click', closeQuoteModal);
  modal.addEventListener('click', function (e) {
    if (e.target === modal) closeQuoteModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('fam-open')) closeQuoteModal();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var descPanel = document.querySelector('[data-fam-tab-panel="desc"]');
  var stickyBar = document.querySelector('[data-fam-sticky-quote-bar]');
  if (!descPanel || !stickyBar) return;

  var marker = descPanel.querySelector('p') || descPanel.firstElementChild;
  if (!marker) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.boundingClientRect.top < 0) {
        stickyBar.classList.add('fam-visible');
      } else {
        stickyBar.classList.remove('fam-visible');
      }
    });
  }, { threshold: 0 });

  observer.observe(marker);
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-fam-recommendations]').forEach(function (container) {
    var url = container.getAttribute('data-fam-recs-url');
    if (!url) return;
    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById(container.id);
        if (fresh) container.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  });
});
